export default __webpack_public_path__ + "static/media/1.b3104aa0.png";